import { Routes } from 'config/routes'

const CREDITAS_AFFILIATES_TOKEN = 'creditas-affiliates-token'
const CREDITAS_AFFILIATES_STATE = 'creditas-affiliates-state'
const CREDITAS_AFFILIATES_TOKEN_EXPIRES = 'creditas-affiliates-expires'

const getAffiliatesAuthSession = () =>
  localStorage.getItem(CREDITAS_AFFILIATES_TOKEN)

const getCredentials = () => {
  const token = getAffiliatesAuthSession()

  if (token === null) {
    throw new Error("There's no session storage in local storage")
  }

  return token
}

const destroyCredentials = () => {
  localStorage.removeItem(CREDITAS_AFFILIATES_TOKEN)
}

const storeCredentials = token => {
  localStorage.setItem(CREDITAS_AFFILIATES_TOKEN, token)
}

const getStoreAffiliatesState = () => {
  return JSON.parse(localStorage.getItem(CREDITAS_AFFILIATES_STATE))
}

const storeAffiliatesState = state => {
  localStorage.setItem(CREDITAS_AFFILIATES_STATE, JSON.stringify(state))
}

const removeLoadingLeads = () => {
  const storage = getStoreAffiliatesState()
  const newStorage = {
    ...storage,
    leads: { ...storage.leads, isLoading: false },
  }
  storeAffiliatesState(newStorage)
}

const destroyStorageExpiresSession = () =>
  localStorage.removeItem(CREDITAS_AFFILIATES_TOKEN_EXPIRES)

const getStorageExpiresSession = () =>
  localStorage.getItem(CREDITAS_AFFILIATES_TOKEN_EXPIRES)

const getExpiresSession = () => {
  const TokenExpires = getStorageExpiresSession()

  if (TokenExpires === null) {
    throw new Error("There's no expire session storage in local storage")
  }

  return TokenExpires
}

const isSessionExpired = () => {
  try {
    return Date.parse(getExpiresSession()) <= Date.now()
  } catch {
    return true
  }
}

const removeSession = () => {
  destroyCredentials()
  destroyStorageExpiresSession()
  window.location.assign(Routes.Login)
}
export {
  getAffiliatesAuthSession,
  getCredentials,
  destroyCredentials,
  storeCredentials,
  storeAffiliatesState,
  getStoreAffiliatesState,
  removeLoadingLeads,
  removeSession,
  getExpiresSession,
  isSessionExpired,
}
